/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AvailableLanguageViewModel } from "../types/AvailableLanguageViewModel.ts";

export const availableLanguageViewModelSchema = z.object({
  cultureInfo: z.string().nullish(),
  displayName: z.string().nullish(),
}) as unknown as ToZod<AvailableLanguageViewModel>;
